import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CasheaAnnouncementVariant } from '@common/constants/cashea-announcement';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/** Cómo se cerró el anuncio sin usar el botón principal. */
export type CasheaAnnouncementDismiss = 'later' | 'close_button';

/**
 * Anuncio de Cashea que se muestra una vez al entrar (ver `CasheaAnnouncementService`). Cierra con
 * `'cta'` si el usuario toca el botón principal; cualquier otra salida es un dismiss.
 */
@Component({
    selector: 'fina-cashea-announcement-modal',
    templateUrl: './cashea-announcement-modal.component.html',
    styleUrls: ['./cashea-announcement-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CasheaAnnouncementModalComponent {
    @Input() variant: CasheaAnnouncementVariant = 'connect';
    /** Si puede pedir la conexión (tiene acceso a Cuentas por cobrar). Si no, el anuncio solo informa. */
    @Input() canRequest = true;

    constructor(public activeModal: NgbActiveModal) {}

    get isLink(): boolean {
        return this.variant === 'link';
    }

    get title(): string {
        return this.isLink ? 'Ahora también vende a distancia con Cashea Link' : 'Vende en cuotas con Cashea, también a distancia';
    }

    get subtitle(): string {
        return this.isLink
            ? 'Ya cobras con Cashea QR. Con Cashea Link le envías un link de pago a tu cliente y compra desde donde esté, sin pasar por la tienda.'
            : 'Envíale a tu cliente un link de pago por WhatsApp o cobra con QR en tu tienda: paga una inicial y el resto en cuotas con Cashea, y Fina registra cada pago por ti.';
    }

    get ctaLabel(): string {
        return this.isLink ? 'Activar Cashea Link' : 'Solicitar conexión';
    }

    primary(): void {
        if (!this.canRequest) {
            this.activeModal.dismiss('later');
            return;
        }
        this.activeModal.close('cta');
    }

    dismiss(reason: CasheaAnnouncementDismiss): void {
        this.activeModal.dismiss(reason);
    }
}
